import '../styles/notfoundunauthorized.css'
import React from 'react';
import unauthorizedImg from '../img/unauthorized.svg'

function Unauthorized() {



    return (
        <section className='Unauthorized-content'>
            <div className='body-Unauthorized'>
            <div className='img-not-found'>
                    <img src={unauthorizedImg}  className='img-not-found' />
                </div>
                <div className='title-Unauthorized'>
                    <h1>Oops! Error 401</h1>
                    <h2>Sorry, this page is unavailable as your access is restricted to this functionality.</h2>
                </div>
            </div>
        </section>
    )
}


export default Unauthorized